"use client";

import * as React from "react";
import Svg from "./Svg";
import * as Presets from "./presets";
const Skeleton = ({
  preset,
  ...props
}) => {
  const Component = preset ? Presets[preset] : Svg;
  return /*#__PURE__*/React.createElement(Component, props);
};
export default Skeleton;